import React from "react";
import { Box, FormControlLabel, Paper, Switch, Typography } from "@mui/material";

const MarginLockToggle = ({ operatorDetails, onChange, canEditMargins }: any) => {
  const isLocked = operatorDetails?.operatorMargins?.EXTRA_DATA?.isMarginEditingAllowed;

  return (
    <Paper
      elevation={2}
      sx={{
        p: 3,
        mb: 2,
        borderRadius: 2,
        backgroundColor: isLocked ? '#e8f5e8' : '#fff3e0',
        border: isLocked ? '2px solid #4caf50' : '2px solid #ff9800',
        position: 'relative',
        '&::after': {
          content: '""',
          position: 'absolute',
          bottom: '-2px',
          left: '50%',
          transform: 'translateX(-50%)',
          width: 0,
          height: 0,
          borderLeft: '10px solid transparent',
          borderRight: '10px solid transparent',
          borderTop: isLocked ? '10px solid #4caf50' : '10px solid #ff9800',
        }
      }}
    >
      <Box display="flex" alignItems="center" justifyContent="space-between">
        <Box display="flex" alignItems="center" gap={2}>
          <Box
            sx={{
              width: 40,
              height: 40,
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              backgroundColor: isLocked ? '#4caf50' : '#ff9800',
              color: 'white',
              fontSize: '20px'
            }}
          >
            {isLocked ? '🔓' : '🔒'}
          </Box>
          <Box>
            <Typography
              variant="h6"
              sx={{
                fontWeight: 'bold',
                color: isLocked ? '#2e7d32' : '#f57c00',
                mb: 0.5
              }}
            >
              {isLocked ? '🔓 Editing Mode Enabled' : '🔒 Read-Only Mode'}
            </Typography>
            <Typography variant="body2" color="textSecondary">
              {isLocked
                ? 'Bet Limits and Margin sections are now editable'
                : 'Bet Limits and Margin sections are locked for editing'
              }
            </Typography>
          </Box>
        </Box>
        <Box display="flex" alignItems="center" gap={2}>
          <Typography
            variant="body1"
            sx={{
              fontWeight: 'bold',
              color: isLocked ? '#2e7d32' : '#f57c00'
            }}
          >
            {isLocked ? "Unlocked" : "Locked"}
          </Typography>
          <FormControlLabel
            control={
              <Switch
                checked={isLocked || false}
                onChange={onChange}
                name="adminLock"
                disabled={!canEditMargins}
                size={"medium" as any}
                sx={{
                  '& .MuiSwitch-switchBase.Mui-checked': {
                    color: '#4caf50',
                  },
                  '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                    backgroundColor: '#4caf50',
                  },
                }}
              />
            }
            label=""
          />
        </Box>
      </Box>
    </Paper>
  );
};

export default MarginLockToggle;